<template>
  <defs>
    <pin-spot />
    <pin-spot-full />
    <pin-spot-restroom-male />
    <pin-spot-restroom-female />
    <pin-spot-restroom-shared />
    <pin-spot-dome />
    <pin-person />
    <visualization-setstar />
    <visualization-sound />
    <visualization-eco2 />
    <visualization-wind-speed />
  </defs>
</template>

<script>
import pinSpot from './visualization/spot_pin/default.vue';
import pinSpotFull from './visualization/spot_pin/full.vue';
import pinSpotRestroomMale from './visualization/spot_pin/restroom_male.vue';
import pinSpotRestroomFemale from './visualization/spot_pin/restroom_female.vue';
import pinSpotRestroomShared from './visualization/spot_pin/restroom_shared.vue';
import pinSpotDome from './visualization/spot_pin/dome.vue';
import pinPerson from './visualization/person_pin.vue';
import visualizationSetstar from './visualization/setstar.vue';
import visualizationSound from './visualization/sound.vue';
import visualizationEco2 from './visualization/eco2.vue';
import visualizationWindSpeed from './visualization/wind_speed.vue';

export default {
  components: {
    pinSpot,
    pinSpotFull,
    pinSpotRestroomMale,
    pinSpotRestroomFemale,
    pinSpotRestroomShared,
    pinSpotDome,
    pinPerson,
    visualizationSetstar,
    visualizationSound,
    visualizationEco2,
    visualizationWindSpeed,
  },
};
</script>



// WEBPACK FOOTER //
// defs.vue?1230deec